import { color, rem, spacing } from '@thiememeulenhoff/lit-sdk';
import { css, CSSResult, unsafeCSS } from 'lit';
import { tagName } from '../../helpers';
import { AlertType, AlertTypes, alertColors, alertTints } from './alert.types';

export const tag = tagName('alert');

const alertTypeStyle = (alertType: AlertType) => {
  const selector = unsafeCSS(`[type=${alertType}]`);
  const iconClass = unsafeCSS(`.alert-icon-${alertType}`);
  const iconColor = alertColors[alertType];
  const tint = alertTints[alertType];

  return css`
    :host(${selector}) {
      border-color: ${color(iconColor, tint)};
      :where(a-icon) {
        color: ${color(iconColor, tint)};
      }
    }

    ${iconClass} {
      color: ${color(iconColor, tint)};
    }
  `;
};

const styles: Array<CSSResult> = [];

styles.push(css`
  :host {
    align-items: flex-start;
    background: ${color('beige', 100)};
    border-inline-start: ${rem(2)} solid;
    border-radius: ${rem(0, 8, 8, 0)};
    box-sizing: border-box;
    color: ${color('grey', 900)};
    display: flex;
    gap: ${spacing(150)};
    inline-size: 100%;
    justify-content: space-between;
    padding: ${spacing(150)};
  }

  :host([variant='inline']) {
    inline-size: max-content;
  }

  :where(a-icon) {
    font-size: ${rem(18)};
    margin-block-start: ${spacing(25)};
    min-inline-size: ${rem(20)};
    &::part(iconSvg) {
      &:where(.fa-primary) {
        fill: ${color('black')};
      }
    }
  }

  :where(span) {
    margin-inline-end: auto;
    padding-inline-end: ${spacing(100)};
  }

  :where(a-icon-button) {
    justify-self: flex-end;
    &::part(button) {
      min-block-size: ${rem(24)};
      min-inline-size: ${rem(24)};
    }
  }
`);

AlertTypes.forEach((type: AlertType) => styles.push(alertTypeStyle(type)));

export const alertStyles = styles;
